import { ElementRef } from '@angular/core';

// Colorify Palette
export type ColorifyPalette = 'white' | 'black' | 'light' | 'dark' | 'primary' | 'link' | 'info' | 'success' | 'warning' | 'danger' | 'transparent' | undefined;

// CanColor Interface
export interface CanColor {
  color?: ColorifyPalette;
  bgColor?: ColorifyPalette;
}

export class Colorify {
  private _color: ColorifyPalette;
  private _bgColor: ColorifyPalette;
  private _selector: ElementRef;

  constructor(private el: ElementRef) {}

  get color(): ColorifyPalette {
    return this._color;
  }

  set color(color: ColorifyPalette) {
    this._color = color;
    this._getClass('is', color);
  }

  get bgColor(): ColorifyPalette {
    return this._bgColor;
  }

  set bgColor(bgColor: ColorifyPalette) {
    this._bgColor = bgColor;
    this._getClass('has-background', bgColor);
  }

  get selector(): ElementRef {
    return this._selector;
  }

  set selector(selector: ElementRef) {
    this._selector = selector;
  }

  private _getClass(classPrefix: string, color: string) {
    if (color) {
      if (this._selector) {
        this._selector.nativeElement.classList.add(`${classPrefix}-${color}`);
      } else {
        this.el.nativeElement.classList.add(`${classPrefix}-${color}`);
      }
    }
  }

}
